/**
 * This events search module works on top of "PCG.UmbracoPlugins.ElasticSearch" plugin.
 * It is used on the "County Council" site.
 */

import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { NouisliderModule } from "ng2-nouislider";

import { DateFilterComponent } from "./components/date-filter/date-filter.component";
import { SearchMessageComponent } from "./components/search-message/search-message.component";
import { ResultItemComponent } from "./components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";
import { EventSearchComponent } from "./event-search.component";

@NgModule({
    declarations: [
        SearchMessageComponent,
        DateFilterComponent,
        EventSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [EventSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class EventSearchModule {
}
